import { inject, Pipe, PipeTransform } from '@angular/core';
import { LanguageService } from '../services/language.service';
import { DOMHandlerService } from '../services/domhandler.service';

@Pipe({
    name: 'customDate',
    standalone: true,
})
export class CustomDatePipe implements PipeTransform {
    languageService = inject(LanguageService);
    domHandler = inject(DOMHandlerService);

    transform(value: string | null | undefined): string {
        if (value === null || value === undefined) {
            return '';
        }
        return this.domHandler.formatDate(
            value,
            this.languageService.getLanguageCode,
        );
    }
}
